import React from 'react';
import { Text } from '../../components';
import { Button } from '@kmx/legos-react-button';
import FailureGraphic from './images/failure-graphic';


const MESSAGE_1 = 'Due to technical issues we are unable to process your data privacy rights request at this time. Please try again at a later time or call the CarMax Privacy Rights line at (833) 987-1241.';
const MESSAGE_2 = 'The file you uploaded exceeds the file size limitation.  Please try again with a file that is smaller than 1 MB  or call the CarMax Privacy Rights line at (833) 987-1241.';


const ErrorPage = ({ showFileUploadError = false }) => {
  const message = showFileUploadError ? MESSAGE_2 : MESSAGE_1;
  return (
    <div className='text-center p-t-xxl m-t-l'>
      <FailureGraphic />
      <Text.Display1>
      {message}
      </Text.Display1>
      <Button
        className='m-t-l p-l-xxl p-r-xxl'
        full={true}
        level='primary'
        type='button'
        onClick={() => {
          window.location.href = '/privacy-policy';
        }}>
        Return to Privacy Policy
      </Button>
    </div>
  );
};

export default ErrorPage;
